import React from "react";

export function fixBody(useFixedPosition: boolean, elementId?: string) {
	if (useFixedPosition) {
		let windowY = document.documentElement.getBoundingClientRect().top;
		document.body.style.position = "fixed";
		document.body.style.top = `${windowY}px`;
	} else {
		const el = document.getElementById(elementId || "");
		if (el != null) {
			el.style.pointerEvents = "auto";
		}
		document.body.style.pointerEvents = "none";
	}
}

export function setBodyOverflow() {
	document.body.style.overflow = "hidden";
}

export function resetBody(
	useFixedPosition: boolean,
	shouldResetView = false,
	elementId?: string
) {
	if (useFixedPosition) {
		const scrollY = document.body.getBoundingClientRect().top;
		document.body.style.position = "";
		if (shouldResetView) {
			document.body.style.top = "";
		}
		window.scrollTo({
			top: (scrollY || 0) * -1,
			behavior: "auto",
		});
	} else {
		const el = document.getElementById(elementId || "");
		if (el != null) {
			el.style.pointerEvents = "";
		}
		document.body.style.pointerEvents = "";
	}
}

export function resetBodyOverflow() {
	document.body.style.overflow = "";
}

export function fixSpecificElementByClass(elemName: string) {
	const el = document.getElementsByClassName(
		elemName
	)[0] as HTMLElement | null;

	if (el == null) {
		return;
	}

	el.style.position = "fixed";
	el.style.top = `${el.getBoundingClientRect().top}px`;
}

export function resetSpecificElementByClass(
	shouldResetView = true,
	elemName: string
) {
	const el = document.getElementsByClassName(
		elemName
	)[0] as HTMLElement | null;
	if (el == null) {
		return;
	}

	el.style.position = "";
	if (shouldResetView) {
		el.style.top = "";
	}
	window.scrollTo(0, el.getBoundingClientRect().top * -1);
}

export function mobileScrollToEndOfElement<T extends HTMLElement>(
	elementRef: React.RefObject<T>
) {
	// set timeout because on mobile themes this is the only way scroll works
	setTimeout(() => {
		elementRef.current?.scrollIntoView({
			block: "end",
			behavior: "smooth",
		});
	}, 100);
}

export function mobileScrollToEndOfPage() {
	const scrollDiv = document.getElementById("scroll-to-bottom");

	if (scrollDiv) {
		setTimeout(() => {
			scrollDiv.scrollIntoView({
				block: "end",
				behavior: "smooth",
			});
		}, 100);

		return;
	}

	const bottomScrollDiv = document.createElement("div");
	bottomScrollDiv.id = "scroll-to-bottom";

	document.querySelector("main")?.appendChild(bottomScrollDiv);

	if (bottomScrollDiv) {
		setTimeout(() => {
			bottomScrollDiv.scrollIntoView({
				block: "end",
				behavior: "smooth",
			});
		}, 100);
	}
}
